"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminRewardsFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var AdminRewardsFactory = /** @class */ (function (_super) {
    __extends(AdminRewardsFactory, _super);
    function AdminRewardsFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    AdminRewardsFactory.prototype.deploy = function (_arcDAO, _rewardsDistribution, _rewardsToken, _stakingToken, _feesToken, overrides) {
        return _super.prototype.deploy.call(this, _arcDAO, _rewardsDistribution, _rewardsToken, _stakingToken, _feesToken, overrides || {});
    };
    AdminRewardsFactory.prototype.getDeployTransaction = function (_arcDAO, _rewardsDistribution, _rewardsToken, _stakingToken, _feesToken, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _arcDAO, _rewardsDistribution, _rewardsToken, _stakingToken, _feesToken, overrides || {});
    };
    AdminRewardsFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    AdminRewardsFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    AdminRewardsFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return AdminRewardsFactory;
}(contracts_1.ContractFactory));
exports.AdminRewardsFactory = AdminRewardsFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_arcDAO",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsDistribution",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_stakingToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_feesToken",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "ClaimableStatusUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reward",
                type: "uint256",
            },
        ],
        name: "RewardPaid",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "arcDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "earned",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "exit",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "getReward",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getRewardForDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getTotalBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "getUserBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "lastTimeRewardApplicable",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "lastUpdateTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "periodFinish",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardPerToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardPerTokenStored",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardsDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardsToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address[]",
                name: "users",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
        ],
        name: "setRewards",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "_enabled",
                type: "bool",
            },
        ],
        name: "setTokensClaimable",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "stake",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tokensClaimable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=AdminRewardsFactory.js.map